import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './ShipperAccount.module.scss';
import SimpleInput from '../../common/SimpleInput';
import { CarrierDisplayName } from '../../../constants/carrierTypes';

function ShipperAccount(props) {
  const { carrier, account } = props;

  const [editing, setEditing] = useState(false);
  const [shipperAccount, setShipperAccount] = useState({
    carrier: carrier || '',
    account: account || '',
  });

  function onChange(e) {
    const { name, value } = e.target;
    setShipperAccount((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  function onSave() {
    setEditing(false);
    props.onSave(shipperAccount);
  }

  if (editing) {
    const options = Object.keys(CarrierDisplayName).map((carrier) => (
      <option key={carrier} value={carrier}>
        {CarrierDisplayName[carrier]}
      </option>
    ));
    options.unshift(
      <option key="none" value="">
        None
      </option>,
    );

    return (
      <div className={styles.shipperAccountContainer}>
        <span onClick={onSave} className={cn(styles.edit, 'ic-save')} data-testid="save-button" />
        <select
          name="carrier"
          value={shipperAccount.carrier}
          onChange={onChange}
          className={styles.select}
          data-testid="carrier"
        >
          {options}
        </select>

        <SimpleInput name="account" value={shipperAccount.account} onChange={onChange} data-testid="account" />
      </div>
    );
  } else {
    const hasShipperAccount = shipperAccount.carrier && shipperAccount.account;
    const shipperAccountcarrier = CarrierDisplayName[shipperAccount.carrier] || 'None';

    return (
      <div className={styles.shipperAccountContainer}>
        <span onClick={() => setEditing(true)} className={cn(styles.edit, 'ic-edit')} data-testid="edit-button" />
        {hasShipperAccount ? (
          <span className={styles.value}>
            <b>({shipperAccountcarrier})</b> {shipperAccount.account}
          </span>
        ) : (
          <button onClick={() => setEditing(true)} className={styles.empty} data-testid="add-button">
            Add Shipper Account
          </button>
        )}
      </div>
    );
  }
}

ShipperAccount.propTypes = {
  onSave: PropTypes.func.isRequired,
  carrier: PropTypes.string,
  account: PropTypes.string,
};

export default ShipperAccount;
